module.exports = __webpack_public_path__ + "img/infibo-how-to-subscribe-en-2.ec15f69a.png";